/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-11 16:45:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-01 11:12:04
 * @FilePath: \ioc_base\src\modules\workShop\const\shopManageTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic, Dates } from "$utils";
export const tableOption = function (that) {
  return {
    view: "详情",
    page: true,
    selection: true,
    index: true,
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    emptyText: "暂无数据",
    column: [
      {
        label: "角色名称",
        prop: "accountGroupName",
        search: true,
        clearable: true
      },

      {
        label: "创建人",
        prop: "creator"
      },
      {
        label: "创建时间",
        prop: "createTime",
        formatter: (row, info) => {
          if (info !== null && info !== "") {
            return Dates.format(new Date(info));
          } else {
            return "";
          }
        }
      },
      {
        label: "最后修改时间",
        prop: "modifyTime",
        formatter: (row, info) => {
          if (info !== null && info !== "") {
            return Dates.format(new Date(info));
          } else {
            return "";
          }
        }
      },
      {
        label: "备注",
        prop: "desc"
      }
    ]
  };
};
export default tableOption;
